import Call from "@mui/icons-material/Call";
import worshipbackground from "./images/worshipwallpaper.jpg";
import pastorPic2 from "./images/pstabpic2.jpg";
import porciaPic from "./images/porcia.jpg";
import pastorpaul from "./images/pstpaul.jpg";
import ghanaflag from "./images/ghanaflag.png";
import footerbackground from "./images/best3.jpg"
import { useEffect, useState } from "react";
import db, { realtimeDB } from "./Backend";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { get, ref } from "firebase/database";
import LiveVideoPlayer from "./LiveVideoPlayer";
import { Link, useNavigate } from "react-router-dom";
import UseLayout from "./UseLayout";
import ScrollTrigger from "react-scroll-trigger";
import { HbrPauseIcon, HbrPlayButton, HbrTvIcon } from "./MyCustomsvgicons";
import ReactPlayer from "react-player";
import gsap from "gsap";
import holinesstvback from "./images/tvadbackground.png";
import holinesstvlogo from "./images/holinesstvbanner.jpg";
import PublishedTestimonies from "./newComponent/PublishedTestimonies";

const FooterInfo = () => {
    const [data,setData]= useState([]);
    const childKey = 1;
    const [videoTitle,setVideoTitle]=useState("");
    const [liveStarted,setLivestarted]=useState(false);
    const [playing,setIsPlaying]=useState(false);
    const [aboutTvInfo,setAboutTvInfo]=useState("");
    const [testimonies,setTestimonies]=useState([]);
    const [yearTestified,setYeartestified]=useState("");
    const {width}=UseLayout();
    const navigate = useNavigate();

    useEffect(()=>{
            const unsub = onSnapshot(collection(db,"events"),(snapshot)=>{
                    const items =[];
                snapshot.forEach((doc)=>{
                    items.push(doc.data());
                });
                setData(items);
            });
            return unsub;
        
    },[]);

    useEffect(()=>{
        async function fetchVideoData() {
          const vidTitlesnapshot = await get(ref(realtimeDB,"videoplayer/title"));
            setVideoTitle(vidTitlesnapshot.val());
            const livesnapshot = await get(ref(realtimeDB,"videoplayer/live"));
            setLivestarted(livesnapshot.val());
            const aboutTvsnapshot = await get(ref(realtimeDB, "general info/tv footer"));
            if (aboutTvsnapshot.exists()) {
                setAboutTvInfo(aboutTvsnapshot.val());   
            }
        }
        fetchVideoData();
    },[]);

    useEffect(()=>{
        const currentDate = new Date();
        setYeartestified(currentDate.getFullYear().toString());
      },[yearTestified]);
  
      useEffect(()=>{
        const collectionref = collection(db,"testimonyApproved");
      //   const q = query(collectionref,where("year","==",yearTestified), orderBy("timestamp","desc"));
      const q = query(collectionref, orderBy("timestamp","desc"));
        try{
            const unsub = onSnapshot(q,(snapshot)=>{
                 const getdata = [];
                 snapshot.forEach((doc)=>{
                     getdata.push(doc.data());
                 });
                 setTestimonies(getdata);
            });
             return unsub;
         }catch(err){
             console.log(err);
         }
      },[yearTestified]);

    return ( 
        <div className="more-info flex-column2">

                <div className="tvContainer" >
                    <div className="flex-row2" style={{position:"absolute",top:"7%",width:"100%"}}>
                        <Link to={"https://horemowbookreaderlite.web.app/holinesstv"} className="flex-row2" style={{width:"200px", borderRadius:"10px",backgroundColor:"white",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.   19), 0px 6px 6px rgba(0, 0, 0, 0.23)",boxSizing:"border-box",padding:"10px",zIndex:"1",cursor:"pointer", textDecoration:"none"}}>
                            <h2 style={{color:"black"}}>Watch Tv</h2>
                            <HbrTvIcon width="1.7em" height="1.7em" fillColour="#eb268f" />
                        </Link>
                    </div>
                    
                    <ScrollTrigger onEnter={()=>gsap.fromTo('#tvcommercialhomeanimate',
                    {x:100,opacity:0},{x:0,opacity:1,duration:3})} className="scrolltrigger" >
                    <div id="tvcommercialhomeanimate" className="tvcommercialonhomepage" >
                    
                        <div style={{width:"100%",height:"100%",position:"relative",borderRadius:"10px",background:"#101010"}}>
                            {playing && 
                            <div className="pausetvvommercialonhome flex-row2" onClick={()=>setIsPlaying(false)}>
                            <HbrPauseIcon  width="2em" height="2em" fillColour="white"/>
                            </div>
                            }
                            {!playing && 
                                <div className="starttvvommercialonhome flex-row2" onClick={()=>setIsPlaying(true)}>
                                <HbrPlayButton  width="2em" height="2em" fillColour="white"/>
                            </div>
                            }
                    
                        {/* {playing && <div className="playeroverlay"></div>}  */}
                        <div className="playeroverlay"></div>
                            <ReactPlayer
                            url={"https://youtu.be/wMxDRzij-og"}
                            playing={playing}
                            loop
                            width={"100%"}
                            height={"100%"}
                            config={{
                                youtube:{
                                    playerVars:{
                                        modestbranding:1,
                                        controls:0,
                                        showinfo:0,
                                    }
                                }
                            }}
                        />
                        </div>
                    </div>
                    </ScrollTrigger>
          
                    <ScrollTrigger onEnter={()=>gsap.fromTo('#holinesstvlogohomedisplay',
                    {x:100,opacity:0},{x:0,opacity:1,duration:3})} className="scrolltrigger" >
                      <img id="holinesstvlogohomedisplay" src={holinesstvlogo} alt=""/>
                    </ScrollTrigger>
                   

                    <ScrollTrigger onEnter={()=>gsap.fromTo('#tvbackhomedisplay',
                    {x:100,opacity:0},{x:0,opacity:1,duration:3})} className="scrolltrigger" >
                      <div style={{width:"100%",height:"600px"}}>
                      <img id="tvbackhomedisplay" src={holinesstvback} alt= "" style={{
                      width:"100%",
                      height:"100%",
                      objectFit:"cover"
                      }}/>
                      </div>
                    </ScrollTrigger>
            
                
                    <div className="abouttvhomedisplaydiv" style={{width:"80%",height:"auto",zIndex:"1",background:"#101010",borderRadius:"10px",position:"absolute",padding:"15px"}}>
                        <ScrollTrigger onEnter={()=>gsap.fromTo('#abouttvtext',
                          {y:100,opacity:0},{y:0,opacity:1,duration:3})} className="scrolltrigger">
                              <pre id="abouttvtext" style={{color:"white", fontWeight:"bold",whiteSpace:"pre-wrap"}}>
                                {aboutTvInfo && aboutTvInfo}
                              </pre>
                      </ScrollTrigger>
                  </div>
                </div>

                <button onClick={()=>navigate("horemowghvideos")} style={{padding:"10px",color:"red",border:"none",backgroundColor: "white", fontWeight:"bold", fontSize:"1.2em", marginTop:"1em",cursor:"pointer" ,borderRadius:"10px",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)"}}>
                    Watch More Videos
                </button>

                  <button onClick={()=>navigate("testimonies")} 
                             style={{padding:"10px",color:"red",border:"none",backgroundColor: "white", fontWeight:"bold", fontSize:"1.2em",cursor:"pointer" ,borderRadius:"10px",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)"}}>
                   Share Your Testimony, Vision, Dreams, etc
                </button>

                <Link to={"https://horemowbookreaderlite.web.app/hrmwenglishbooks"}
                             style={{padding:"10px",color:"red",border:"none",backgroundColor: "white", fontWeight:"bold", fontSize:"1.2em",cursor:"pointer" ,borderRadius:"10px",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)", textDecoration:"none"}}>
                   Get Access to Free e-books
                </Link>

                <Link to={"https://horemowbookreaderlite.web.app/audioBooks"}
                             style={{padding:"10px",color:"red",border:"none",backgroundColor: "white", fontWeight:"bold", fontSize:"1.2em",cursor:"pointer" ,borderRadius:"10px",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)", textDecoration:"none"}}>
                    Get Access to Free Audio Books
                </Link>

                <Link to={"https://horemowbookreaderlite.web.app/divineblogs"}
                             style={{padding:"10px",color:"red",border:"none",backgroundColor: "white", fontWeight:"bold", fontSize:"1.2em",cursor:"pointer" ,borderRadius:"10px",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)", textDecoration:"none"}}>
                   Divine Blogs
                </Link>

                <Link to={"https://horemowbookreaderlite.web.app/horemow_video_messages"}
                             style={{padding:"10px",color:"red",border:"none",backgroundColor: "white", fontWeight:"bold", fontSize:"1.2em",cursor:"pointer" ,borderRadius:"10px",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)", textDecoration:"none"}}>
                   Horemow Video Messages
                </Link>

                <Link to={"https://horemowbookreaderlite.web.app/horemow_audio_messages"}
                             style={{padding:"10px",color:"red",border:"none",backgroundColor: "white", fontWeight:"bold", fontSize:"1.2em",cursor:"pointer" ,borderRadius:"10px",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)", textDecoration:"none"}}>
                   Horemow Audio Messages
                </Link>

        

                 <div className="flex-column1" style={{width:"90%",height:"auto",borderRadius:"10px",gap:"20px",backgroundColor:"black",padding:"10px"}}>
                    <h4 style={{color:"white"}}>{`Video: ${videoTitle}`}</h4>
                    {liveStarted && 
                      <div className="flex-row2" style={{gap:"10px"}}>
                        <Link to={`horemowghlive`} style={{color:"#0E78F9",fontWeight:"bold",backgroundColor:"white",borderRadius:"10px",padding:"8px",textDecoration:"none"}}>
                            Click here
                        </Link>
                    
                        <h4 style={{color:"white"}}> to visit the live program page for better viewing experience
                        </h4>
                      </div>
                    }
                    
                    {width <= 540 ?   <LiveVideoPlayer vidwidth={"100%"} vidheight={"50vh"}/>
                    :  <LiveVideoPlayer vidwidth={"100%"} vidheight={"70vh"}/>
                        
                    }
                  
                </div>
            {
                data && data.map(data => (
                    <div className="upcoming-program flex-column2" style={{backgroundImage:`url(${worshipbackground})`}} key={childKey}>
                    <h1 style={{color:"white", fontWeight:"bolder",fontFamily:"sans-serif",padding:"10px"}}>
                        Upcoming National Event!!!
                    </h1>
                    <div className="eventtext">
                        <h3>{data.eventDetails}</h3>
                    </div>
                    <img src={data.image} alt="upcoming event flyer"/>
                </div>
                ))
            }

            <h4>Testimonies, visions, dreams, etc</h4>

            {testimonies && testimonies.map(data => (
                <PublishedTestimonies
                    key={data.timestamp}
                    username={data.username}
                    user_unit={data.user_unit}
                    user_chapter={data.user_chapter}
                    year={data.year}
                    dateSent={data.dateSent}
                    timestamp={data.timestamp}
                    testimony={data.testimony}
                    displaypic={data.displaypic}
                    senderID={data.senderID}
                />
            ))}

            {/* <div className="horemowbookreaderframe">
            <iframe src="" width={"100%"} height={"100%"} title="divine blogs"></iframe>
            </div> */}
            
      
            <div className="profiles">
                <div className="officer">
                    <div className="officername">
                        <h3>Pastor Paul Rika</h3>
                        <p style={{color:"black",fontWeight:"bold"}}>
                            International Director - Abuja, Nigeria
                        </p>
                    </div>
                        <img src={pastorpaul} alt="pastor paul rika"/>
                </div>
                <div className="officer">
                        <div className="officername">
                        <h3>Pastor Abraham Agordo</h3>
                        <p style={{color:"black",fontWeight:"bold"}}>
                            National Coordinator - Ghana
                        </p>
                        </div>
                
                        <img src={pastorPic2} alt="pastor abraham agordo"/>
                </div>
               
                <div className="officer">
                    <div className="officername">
                        <h3>Porcia Agordo</h3>
                        <p style={{color:"black",fontWeight:"bold"}}>
                            Wife of National Coordinator - Ghana
                        </p>
                    </div>
                        <img src={porciaPic} alt="porcia agordo"/>
                </div>
        
            </div>
            <div className="footernote" style={{backgroundImage:`url(${footerbackground})`}}>
                <img src={ghanaflag} alt="Ghana flag"/>
       
                <div className="social-info">
                    <div className="follow-us">
                        <h2>Follow us</h2>
                        <a href="https://web.facebook.com/pastorpaulrika/">  
                        <svg
                        viewBox="0 0 24 24"
                        style={{backgroundColor:"white",borderRadius:"50%"}}
                        fill="#4267B2"
                        height="40px"
                        width="40px">
                        <path d="M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z" />
                        </svg>
                        HoremowGh Multimedia
                        </a> <br/><br/> 

                        <a href="https://youtube.com/c/PASTORPAULRIKA1">
                        <svg
                        viewBox="0 0 24 24"
                        fill="red"
                        height="40px"
                        width="40px">
                        <path d="M21.593 7.203a2.506 2.506 0 00-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 00-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 001.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z" />
                        </svg>
                            Pastor Paul Rika
                            </a> <br/><br/>

                        <a href="https://www.instagram.com/officialpastorpaulrika">
                        <svg
                        viewBox="0 0 24 24"
                        fill="#833ab4"
                        height="40px"
                        width="40px">
                        <path d="M11.999 7.377a4.623 4.623 0 100 9.248 4.623 4.623 0 000-9.248zm0 7.627a3.004 3.004 0 110-6.008 3.004 3.004 0 010 6.008z" />
                        <path d="M17.884 7.207 A1.078 1.078 0 0 1 16.806 8.285 A1.078 1.078 0 0 1 15.728000000000002 7.207 A1.078 1.078 0 0 1 17.884 7.207 z" />
                        <path d="M20.533 6.111A4.605 4.605 0 0017.9 3.479a6.606 6.606 0 00-2.186-.42c-.963-.042-1.268-.054-3.71-.054s-2.755 0-3.71.054a6.554 6.554 0 00-2.184.42 4.6 4.6 0 00-2.633 2.632 6.585 6.585 0 00-.419 2.186c-.043.962-.056 1.267-.056 3.71 0 2.442 0 2.753.056 3.71.015.748.156 1.486.419 2.187a4.61 4.61 0 002.634 2.632 6.584 6.584 0 002.185.45c.963.042 1.268.055 3.71.055s2.755 0 3.71-.055a6.615 6.615 0 002.186-.419 4.613 4.613 0 002.633-2.633c.263-.7.404-1.438.419-2.186.043-.962.056-1.267.056-3.71s0-2.753-.056-3.71a6.581 6.581 0 00-.421-2.217zm-1.218 9.532a5.043 5.043 0 01-.311 1.688 2.987 2.987 0 01-1.712 1.711 4.985 4.985 0 01-1.67.311c-.95.044-1.218.055-3.654.055-2.438 0-2.687 0-3.655-.055a4.96 4.96 0 01-1.669-.311 2.985 2.985 0 01-1.719-1.711 5.08 5.08 0 01-.311-1.669c-.043-.95-.053-1.218-.053-3.654 0-2.437 0-2.686.053-3.655a5.038 5.038 0 01.311-1.687c.305-.789.93-1.41 1.719-1.712a5.01 5.01 0 011.669-.311c.951-.043 1.218-.055 3.655-.055s2.687 0 3.654.055a4.96 4.96 0 011.67.311 2.991 2.991 0 011.712 1.712 5.08 5.08 0 01.311 1.669c.043.951.054 1.218.054 3.655 0 2.436 0 2.698-.043 3.654h-.011z" />
                        </svg>
                            officialpastorpaulrika
                        </a> <br/><br/>
                    </div>
                    <div className="contact-us">
                        <h2>Contact us</h2>
                        <a href="mailto:hbrsoftteam@gmail.com">
                        <svg
                        viewBox="0 0 24 24"
                        fill="#4285F4"
                        height="40px"
                        width="40px">
                        <path d="M18.73 5.41l-1.28 1L12 10.46 6.55 6.37l-1.28-1A2 2 0 002 7.05v11.59A1.36 1.36 0 003.36 20h3.19v-7.72L12 16.37l5.45-4.09V20h3.19A1.36 1.36 0 0022 18.64V7.05a2 2 0 00-3.27-1.64z" />
                        </svg>
                            Send us Mail
                        </a> <br/>

                        <a id="whatsapp-phone" style={{display:"none"}} href="https://api.whatsapp.com/send?phone=%s+233272858683">
                        <svg
                        viewBox="0 0 24 24"
                        fill="#128C7E"
                        height="40px"
                        width="40px"
                        >
                        <path
                            fillRule="evenodd"
                            d="M18.403 5.633A8.919 8.919 0 0012.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 004.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 00-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 01-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 01-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 015.275 2.188 7.42 7.42 0 012.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 00-.429-.008.826.826 0 00-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263"
                            clipRule="evenodd"
                        />
                        </svg>
                            +233 548 186 778
                        </a> <br/>

                        <a id="whatsapp-desktop"
                        href={`https://wa.me/233257444331?text=Hello%20Anybody%20available%20to%20Chat?`}
                        target="_blank" 
                        rel="noreferrer"
                        style={{display:"block"}}>
                             <svg
                            viewBox="0 0 24 24"
                            fill="#128C7E"
                            height="40px"
                            width="40px"
                            >
                            <path
                                fillRule="evenodd"
                                d="M18.403 5.633A8.919 8.919 0 0012.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 004.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 00-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 01-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 01-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 015.275 2.188 7.42 7.42 0 012.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 00-.429-.008.826.826 0 00-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263"
                                clipRule="evenodd"
                            />
                            </svg>
                        WhatsApp
                        </a> <br/>

                        <h3 style={{fontWeight:"bolder",fontSize:"1.5rem",color:"white"}}>
                           <Call/>+233 548 186 778
                        </h3>

                  </div>
                </div>
                <p style={{color:"white",fontSize:"25px",fontWeight:"bolder",margin:"20px"}}>
                Holiness Revival Movement WorldWide - Ghana Chapter.
                     All Rights Reserved 2023
                </p>
            </div>
    </div>
     );
}
 
export default FooterInfo;